module.exports = __webpack_public_path__ + "img/lights_active.fbefbeeb.svg";